import { render, staticRenderFns } from "./ExpressLabelsTableUserTableMobile.vue?vue&type=template&id=5897aa11&scoped=true"
import script from "./ExpressLabelsTableUserTableMobile.vue?vue&type=script&lang=js"
export * from "./ExpressLabelsTableUserTableMobile.vue?vue&type=script&lang=js"
import style0 from "./ExpressLabelsTableUserTableMobile.vue?vue&type=style&index=0&id=5897aa11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897aa11",
  null
  
)

export default component.exports